//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Genre

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The artist model
* 
* @param artistId The artist id
* @param artistName The artist name
* @param blurHash Sets the blur hash
* @param dbVersion The version from db. Used for requesting updates based on a version.
* @param genres The genres
* @param headerImage The artist header image url
* @param iconImage The artist header icon url
* @param isFollowed Defines if the artist is followed by the user
* @param publisher The artist publisher
* @param userScore The user score. Used for sorting/boosting.
* @param website The website url of the event
*/
@Serializable

data class Artist (


      /* The artist id */
    @SerialName(value = "artistId") @Required val artistId: kotlin.Int,


      /* The artist name */
    @SerialName(value = "artistName") @Required val artistName: kotlin.String,


      /* Sets the blur hash */
    @SerialName(value = "blurHash") val blurHash: kotlin.String? = null,


      /* The version from db. Used for requesting updates based on a version. */
    @SerialName(value = "dbVersion") val dbVersion: kotlin.Long? = 0L,


      /* The genres */
    @SerialName(value = "genres") val genres: kotlin.collections.List<Genre>? = null,


      /* The artist header image url */
    @SerialName(value = "headerImage") val headerImage: kotlin.uuid.Uuid? = null,


      /* The artist header icon url */
    @SerialName(value = "iconImage") val iconImage: kotlin.uuid.Uuid? = null,


      /* Defines if the artist is followed by the user */
    @SerialName(value = "isFollowed") val isFollowed: kotlin.Boolean? = null,


      /* The artist publisher */
    @SerialName(value = "publisher") val publisher: kotlin.String? = null,


      /* The user score. Used for sorting/boosting. */
    @SerialName(value = "userScore") val userScore: kotlin.Double? = null,


      /* The website url of the event */
    @SerialName(value = "website") val website: kotlin.String? = null


) {




  }

